import {
    PROMOZAVR_PERSISTENT_PROJECT,
    PROMOZAVR_PERSISTENT_QUEUE,
    PROMOZAVR_PROJECT,
    PROMOZAVR_REGULAR_QUEUE,
    type PromozavrQueueKind,
} from './types';

const PROMOZAVR_PROJECT_BY_QUEUE: Record<
    PromozavrQueueKind,
    typeof PROMOZAVR_PROJECT | typeof PROMOZAVR_PERSISTENT_PROJECT
> = {
    [PROMOZAVR_REGULAR_QUEUE]: PROMOZAVR_PROJECT,
    [PROMOZAVR_PERSISTENT_QUEUE]: PROMOZAVR_PERSISTENT_PROJECT,
};

export function getPromozavrProjectByQueue(queue: PromozavrQueueKind) {
    return PROMOZAVR_PROJECT_BY_QUEUE[queue];
}
